import React from "react"
import ReactMarkdown from "react-markdown"
import FluidImage from "./FluidImage"
import Button from "./Button"
import ImageButton from "./ImageButton"
import IconButton from "./IconButton"
import dayjs from "dayjs"

const PanelContent = ({
  title,
  text,
  text_secondary,
  videos,
  images,
  links,
  icons,
  exposition
}) => {
  return (
    <div className="panel__content">
      {title ? <h3>{title}</h3> : null}
      {videos && videos.length > 0
        ? videos.map((video, index) => (
            <ImageButton
              key={index}
              image={video.image}
              link={video.link}
              title={video.title}
              subtitle={video.subtitle}
              duration={video.duration}
            />
          ))
        : null}
      {text_secondary ? (
        <ReactMarkdown
          source={text_secondary}
          className="paragraph--primary"
          renderers={{
            link: props => (
              <a href={props.href} target="_blank" rel="noopener noreferrer">
                {props.children}
              </a>
            )
          }}
        />
      ) : null}
      {text ? (
        <ReactMarkdown
          source={text}
          className="paragraph--secondary"
          renderers={{
            link: props => (
              <a href={props.href} target="_blank" rel="noopener noreferrer">
                {props.children}
              </a>
            )
          }}
        />
      ) : null}
      {icons && icons.length > 0 ? (
        <div className="panel__icons">
          {icons.map((icon, index) => (
            <IconButton
              key={index + "/link"}
              icon={icon.icon}
              link={icon.link}
            />
          ))}
        </div>
      ) : null}
      {images && images.length > 0 ? (
        <div className="panel__gallery">
          {images.map((image, index) => (
            <FluidImage key={index + "/image"} image={image.image} alt="" />
          ))}
        </div>
      ) : null}
      {links && links.length > 0
        ? links.map((link, index) => (
            <Button
              key={index + "/link"}
              label={link.label}
              label_secondary={link.label_secondary}
              link={link.link}
            />
          ))
        : null}
      {exposition && !exposition.exposition_hide ? (
        <div className="panel__exposition">
          <h4>Exposition à venir</h4>
          {exposition.exposition_date && (
            <h6>{dayjs(exposition.exposition_date).format("DD/MM/YYYY")}</h6>
          )}
          <ReactMarkdown
            source={exposition.exposition_text}
            className="panel__exposition-paragraph"
            renderers={{
              link: props => (
                <a href={props.href} target="_blank" rel="noopener noreferrer">
                  {props.children}
                </a>
              )
            }}
          />
        </div>
      ) : null}
    </div>
  )
}

export default PanelContent
